<template>
  <div class="report-error">
    <a @click="$router.go(-1)" class="button return-button">
      <img src="../assets/pictos/back-arrow.svg">
      Retour au détail
    </a>
    <template v-if="errorSent === false">
      <div class="head">
        <h2>Une erreur ? Signalez-la, nous la corrigerons.</h2>
      </div>
      <div class="form">
        <h3>Formulaire de signalement d’erreur</h3>
        <p class="annotation">Tous les champs sont obligatoires.</p>
        <div class="form-container">
          <div class="question">
            <label for="objet">Objet de l’erreur<sup>*</sup></label>
            <input type="text" id="objet" v-model="formDatas.objet">
          </div>
          <div class="question">
            <label>Nature de l’erreur<sup>*</sup></label>
            <drop-down v-model="formDatas.type"
               :options="errorTypes"
               :searchable="false"
               track-by="value"
               label="label"
               placeholder="Choisissez la nature de l'erreur"
               select-label=""
               :hide-selected="true">
            </drop-down>
          </div>
          <div class="question">
            <label for="description">Description de l'erreur<sup>*</sup></label>
            <textarea id="description" v-model="formDatas.description"></textarea>
          </div>
          <div class="captcha-wrapper">
            <vue-recaptcha
              sitekey="6LebRO0UAAAAAA6B6xyYsP3v39qZGoCYVlO00Yed"
              :loadRecaptchaScript="true"
              @verify="verifyCaptcha"
              @expired="captcha = false">
            </vue-recaptcha>
          </div>
          <div class="button-wrapper">
            <button @click="reportError" class="button send-button" :disabled="!canSend()">Envoyer</button>
          </div>
        </div>
        <div class="legal-wrapper">
          <p>
            Veuillez ne renseigner dans ce formulaire que les informations nécessaires au traitement de votre demande. Merci de ne pas saisir d’informations sensibles.
            <br><br>
            Toutes les informations renseignées peuvent être utilisées par PIA Production SAS pour le traitement de la demande, à l’issu duquel ces informations ne seront pas conservées.
            <br><br>
            Pour en savoir plus sur la manière dont nous gérons vos données à caractère personnel, veuillez consulter la rubrique «&nbsp;<router-link to="/vos-donnees-et-vos-droits" class="link">Vos données et vos droits</router-link>&nbsp;».
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="head">
        <h2>Votre signalement d'erreur a bien été envoyé.</h2>
      </div>
      <div class="form">
        <p style="text-align: center">
          Nous allons corriger cette erreur très prochainement.
          <br><br>
          Merci et à bientôt.
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import DropDown from 'vue-multiselect'
import VueRecaptcha from 'vue-recaptcha'
import repportErrorService from '../services/RepportErrorService'

export default {
  name: 'ReportError',
  components: {
    DropDown,
    VueRecaptcha
  },
  data () {
    return {
      formDatas: {
        objet: '',
        type: '',
        description: ''
      },
      errorTypes: [
        {
          label: 'Aide obsolète',
          value: 'Aide obsolète'
        },
        {
          label: 'Erreur de contenu',
          value: 'Erreur de contenu'
        },
        {
          label: 'Problème d\'affichage',
          value: 'Problème d\'affichage'
        },
        {
          label: 'Manque d\'information',
          value: 'Manque d\'information'
        },
        {
          label: 'Autres ...',
          value: 'Autres ...'
        }
      ],
      captcha: false,
      errorSent: false
    }
  },
  methods: {
    verifyCaptcha () {
      this.captcha = true
    },
    reportError () {
      if (this.canSend()) {
        repportErrorService.postReportError({
          id_aide: this.$route.params.idAide,
          ...this.formDatas
        })
          .then(response => {
            this.errorSent = true
          })
          .catch(error => {
            console.log(error)
            alert("Le signalement d'erreur n'est pas disponible pour le moment.\nMerci de réessayer dans quelques minutes.")
          })
      }
    },
    canSend () {
      return this.formDatas.objet !== '' && this.formDatas.type !== '' && this.formDatas.description !== '' && this.captcha === true
    }
  }
}
</script>

<style lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';

.report-error {
  position: relative;
  .head {
    margin-top: $v-spacer-xl;
    background-color: $primary-color;
    color: #fff;
    text-align: left;
    padding: 20px 30px;
    border-radius: $radius $radius 0 0;
    h2 {
      margin-top: 0;
    }
  }
  .form {
    text-align: left;
    background-color: #fff;
    padding: $v-spacer 30px;
    border-radius: 0 0 $radius $radius;
    h3 {
      font-weight: 500;
      margin: 0;
    }
    .annotation {
      font-family: $secondary-font;
      font-size: $text-size-md;
      margin-top: 5px;
      color: #3c4650;
    }
    .form-container {
      padding: 0 $h-spacer;
      .question {
        margin-top: $v-spacer-lg;
        display: flex;
        flex-direction: column;
        label {
          margin-bottom: 10px;
          font-size: $text-size;
        }
        input {
          box-sizing: border-box;
          max-width: 450px;
          height: 30px;
          border: 1px solid $border-color;
          border-radius: $radius-sm;
          font-family: $secondary-font;
          font-size: $text-size;
          padding: 0 5px;
          color: $primary-color;
        }
        textarea {
          border: 1px solid $border-color;
          border-radius: $radius-sm;
          font-family: $secondary-font;
          font-size: $text-size;
          padding: 5px;
          color: $primary-color;
          height: 200px;
          max-width: 700px;
        }
        .multiselect {
          max-width: 450px;
          .multiselect__tags {
            border: 1px solid $border-color;
            border-radius: $radius-sm;
          }
          .multiselect__element, .multiselect__single {
            font-family: $secondary-font;
            font-size: $text-size-md;
          }
          .multiselect__option--highlight {
            background-color: $hover-color;
            color: $primary-color;
          }
          .multiselect__select:before {
            border: none;
            background-image: url('../assets/pictos/top-arrow-orange.svg');
            background-position: center;
            background-size: 17px 9px;
            background-repeat: no-repeat;
            width: 100%;
            height: 100%;
            display: inline-block;
            top: 0;
            right: 0;
            margin: 0;
          }
        }
      }
      .captcha-wrapper {
        margin-top: $v-spacer;
      }
      .button-wrapper {
        margin-top: $v-spacer;
        .send-button {
          margin: 0 auto;
          height: 54px;
          width: 150px;
          background-image: $primary-gradient;
          color: #fff;
          font-weight: 700;
          font-family: $secondary-font;
          font-size: $text-size;
          border-radius: $radius-sm;
        }
        .send-button:disabled {
          background-color: #808080;
          background-image: none;
          cursor: not-allowed;
        }
      }
    }
    .legal-wrapper {
      max-width: 650px;
      text-align: left;
      margin: $v-spacer-lg auto 0 auto;
      font-family: $secondary-font;
      font-size: $text-size;
    }
  }
}
</style>
